import { Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'Coach Lynda';
	email = "lynda@coachlynda.com";
	phone = "(403) 850-7956";
	fb = "https://www.facebook.com/CoachLyndaSwitzer/";
	fbtext = "CoachLyndaSwitzer";
	bio_open = false;
	
	openBio = function() {
		this.bio_open = true;
		return false;
	}
}



// WEBPACK FOOTER //
// /Users/rob/Projects/coachlynda/src/app/app.component.ts